<!--
 * @Author: 冯杰
 * @Date: 2021-08-05 10:43:43
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-02-28 15:13:14
 * @FilePath: 头部看板
-->
<template>
  <div class="header-box">
    <div>
      <span class="test">新增凤香荟终端（家）：</span>
      <span class="money">{{ totalInfo.addTotal || 0 }}</span>
    </div>
    <div>
      <span class="test">参与凤香荟终端（家）：</span>
      <span class="money">{{ totalInfo.joinTotal || 0 }}</span>
    </div>
    <div>
      <span class="test">未参与凤香荟终端（家）：</span>
      <span class="money">{{ totalInfo.notJoinTotal || 0 }}</span>
    </div>
    <div>
      <span class="test">涉及人员：</span>
      <span class="money">{{ totalInfo.joinSupplyTotal || 0 }}</span>
    </div>
  </div>
</template>

<script>
import request from '@/found/utils/request';

export default {
  data() {
    return {
      totalInfo: {},
    };
  },
  props: {
    searchFormData: Object,
  },
  components: {},
  watch: {
    searchFormData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.data = val;
        this.getData(val);
      },
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(params) {
      request.post('/cps/v1/web/scanCodeTerminalSupply/queryTotal', params).then((res) => {
        if (res.success) {
          this.totalInfo = res.result;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header-box {
  min-width: 1431px;
  width: 100%;
  height: 80px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  div {
    margin-right: 24px;
    width: 20%;
    height: 80px;
    font-family: PingFangSC-Regular;
    color: #333333;
    border-radius: 4px;
    background-image: linear-gradient(-45deg, #eef6ff 0%, #ffffff 100%);
    box-shadow: 0px 0px 10px 0px rgba(14, 93, 195, 0.1);
    span {
      display: block;
      font-size: 16px;
    }
    .test {
      height: 24px;
      line-height: 24px;
      margin: 0px 0 10px 20px;
    }
    .money {
      font-size: 44px;
      color: #0e5dc3;
      font-weight: 500;
      margin-right: 20px;
      margin-left: 20px;
      text-align: left;
    }
  }
}
</style>
